import { Grid, makeStyles } from "@material-ui/core";
import React from "react";
import { useParams } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { ItemHeader } from "./ItemHeader";
import { Form } from "./Form";
import { NonNullableItemState } from "../../redux/state";
import { ModuleAppBar } from "../ModuleAppBar";
import { useItemState } from "../../hooks/useItemState";
import { CaoScrollableAreaTabs } from "./CaoScrollableAreaTabs";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      marginTop: theme.contentOffsets.AFTER_RECORD_HEADER,
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "25px",
    },
  },
}));

export const Item: React.FC = () => {
  const classes = useStyles();

  const { id } = useParams<{ id: string }>();

  const state = useItemState(id);

  return (
    <div className={classes.root}>
      <ModuleAppBar
        breadcrumbs={[
          {
            label: "",
          },
        ]}
      ></ModuleAppBar>

      <ItemHeader state={state} />

      <Grid container spacing={3}>
        <Grid item md={12} lg={6}>
          {state && state.item ? (
            <Form state={state as NonNullableItemState} />
          ) : (
            <>
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <br />
              <Skeleton variant="rect" height={118} />
            </>
          )}
        </Grid>

        <Grid item md={12} lg={6}>
          <CaoScrollableAreaTabs itemState={state} itemId={id} />
        </Grid>
      </Grid>
    </div>
  );
};
